<template functional>
  <!--  check for listeners.changeHoveredId need for places where ClientContent hasn't changeHoveredId listener -->
  <tr
    @mouseover="listeners.changeHoveredId && listeners.changeHoveredId(props.props._key)"
    @mouseout="listeners.changeHoveredId && listeners.changeHoveredId('')"
  >
    <td class="sc-data-list-select">
      <v-list-item class="ml-0 pl-0 pr-0">
        <v-list-item-action v-if="props.allowSelect" class="ml-0 mr-4">
          <v-checkbox
            primary
            hide-details
            :input-value="props.selected"
            @change="listeners.toggleItem(props.props)"
          />
        </v-list-item-action>
        <component
          :is="$options.components.CommonChip"
          v-if="!props.allowCustomSort"
          class="sc-nbr"
          :class="$options.methods.getNBRPropertyTypeClass(props.props.type)"
          dark
        >
          <span>{{ props.props.number }}</span>
        </component>
      </v-list-item>
    </td>
    <td v-if="props.allowCustomSort" class="sc-data-list-select pl-0">
      <div class="d-flex align-center gap-2 mt-1">
        <v-btn
          icon
          :loading="props.isCustomOrderLoading"
          data-track="availability.tour.move-down"
          @click="listeners['update:tour-sort']({ key: props.props._key, order: props.props.number + 1 })"
        >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <component
          :is="$options.components.CommonChip"
          class="sc-nbr"
          :class="$options.methods.getNBRPropertyTypeClass(props.props.type)"
          dark
        >
          <span>{{ props.props.number }}</span>
        </component>
        <v-btn
          icon
          :loading="props.isCustomOrderLoading"
          data-track="availability.tour.move-up"
          @click="listeners['update:tour-sort']({ key: props.props._key, order: props.props.number - 1 })"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </div>
    </td>
    <td v-if="props.allowPhoto" class="sc-data-list-property-photo">
      <router-link
        :to="$options.methods.getAccountRoute({
          name: 'availability',
          params: { id: props.props._key },
          activeAccountId: props.activeAccountId
        })"
        :disabled="!props.allowLink"
        :event="props.allowLink ? 'click' : ''"
        class="property-name"
        :class="{ 'cursor-default': !props.allowLink }"
      >
        <component
          :is="$options.components.Photo"
          :photo-url="props.props.photo ? props.props.photo.url : ''"
          :transaction-type-label="props.props.status_label"
          class="availability-list-photo"
        />
      </router-link>
    </td>
    <td class="sc-data-list-property-address property-address">
      <div v-if="!props.props.active">
        <v-chip
          x-small
          color="black"
          class="lighten-3 mb-1"
          dark
        >
          Inactive
        </v-chip>
      </div>
      <div class="record-id">Availability ID# {{ props.props._key }}</div>
      <router-link
        :to="$options.methods.getAccountRoute({
          name: 'availability',
          params: { id: props.props._key },
          activeAccountId: props.activeAccountId
        })"
        :disabled="!props.allowLink"
        :event="props.allowLink ? 'click' : ''"
        class="property-name"
        :class="{ 'cursor-default': !props.allowLink }"
      >
        <v-tooltip right>
          <template #activator="{ on }">
            <v-btn
              v-if="$options.methods.getComments(props.props).length"
              style="float: right"
              icon
              v-on="on"
            >
              <v-icon size="20">mdi-comment-text</v-icon>
            </v-btn>
          </template>
          <div style="max-width: 400px">
            {{ $options.methods.getComments(props.props) }}
          </div>
        </v-tooltip>
        <div>
          <span v-if="props.props.property.name">{{ props.props.property.name }}</span>
          <span v-else class="na">n/a</span>
        </div>
        <div style="font-weight: normal">
          <span v-if="props.props.address.street">{{ props.props.address.street }}
            <span v-if="props.props.suite">, Suite {{ props.props.suite }}</span>
          </span>
          <span v-else class="na">n/a</span>
        </div>
        <div style="font-weight: normal">
          <span v-if="props.props.property.address.city || props.props.property.address.state || props.props.property.address.postal">
            {{ props.props.property.address.city }}, {{ props.props.property.address.state }}
            {{ props.props.property.address.postal }}
            <span v-if="props.props.property.address.country !== 'US'">{{ props.props.property.address.country }}</span>
          </span>
          <span v-else class="na">n/a</span>
        </div>
      </router-link>
      <div class="mt-2">
        <component
          :is="$options.components.AvailabilityChipsWrapper"
          :agency-type="props.props.agency_type"
          :in-house="props.props.in_house"
          :status="props.props.status"
          :type="props.props.type"
          :mixed-use="props.props.mixed_use"
          :vacancy-type="props.props.vacancy_type"
          :is-portfolio="props.props.is_portfolio"
          :lease-pending="props.props.lease_pending"
          :contract-pending="props.props.contract_pending"
          :is-published-to-web="props.props.published_to_web.value"
          :transaction-status="props.props.status_label"
          :show-transaction-status="!props.allowPhoto"
        />
      </div>
    </td>
    <td :class="`sc-data-list-property-data ${!$options.methods.isLand(props.props) ? 'available-space' : '' }`">
      <div>
        <component
          :is="$options.components.BuildingSizeLabel"
          :value="props.props.available_space"
        />
      </div>
      <div>
        <component
          :is="$options.components.BuildingSizeLabel"
          :value="props.props.divisible_space"
        />
      </div>
    </td>
    <td class="sc-data-list-property-data">
      <div>
        <component
          :is="$options.components.BuildingSizeLabel"
          :value="props.props.building_size"
        />
      </div>
      <div>
        <component
          :is="$options.components.Label"
          :value="props.props.property.construction_status"
        />&nbsp;
        <component
          :is="$options.components.Label"
          :value="props.props.year_built"
        />
      </div>
      <div class="vacancy">
        <component
          :is="$options.components.Label"
          :value="$options.methods.showVacancyStatus(props.props) ? props.props.vacancy_status : null"
        />
      </div>
    </td>
    <td :class="`sc-data-list-property-data ${$options.methods.isLand(props.props) ? 'available-space' : '' }`">
      <div>
        <template v-if="$options.methods.isValuePresent(props.props.acres)">
          <component
            :is="$options.components.LandSizeLabel"
            :value="props.props.acres"
          />
          <component
            :is="$options.components.POLIcon"
            v-if="props.props.land_pol"
          />
        </template>
        <span v-else class="na">N/A</span>
      </div>
      <div>
        <component
          :is="$options.components.LandSizeLabel"
          :value="props.props.divisible_land_size"
        />
      </div>
    </td>
    <td class="sc-data-list-property-data sc-data-list-core-data">
      <span v-if="props.props.bts">BTS</span>
      <component
        :is="$options.components.BuildingSizeLabel"
        v-else-if="props.props.office_space"
        :value="props.props.office_space"
      />
      <span v-else class="na">N/A</span>
    </td>
    <td class="sc-data-list-door-data sc-data-list-core-data">
      <div>
        <component
          :is="$options.components.BuildingDimensionLabels"
          :value1="props.props.details.building.ceiling_height.min"
          :value2="props.props.details.building.ceiling_height.max"
        />
      </div>
      <div>
        <component
          :is="$options.components.Label"
          :value="props.props.details.loading_doors.doors.truck_level.total"
        />
      </div>
      <div>
        <component
          :is="$options.components.Label"
          :value="props.props.details.loading_doors.doors.ground_level.total"
        />
      </div>
    </td>
    <td class="sc-data-list-property-data sc-data-list-core-data">
      <span v-if="props.props.sprinklers">
        {{ props.props.sprinklers }}
      </span>
      <span v-else class="na">N/A</span>
    </td>
    <td class="sc-data-list-property-data">
      <template v-if="props.props.for_sale">
        <div>
          <component
            :is="$options.components.AvailabilitySalesPriceLabel"
            :availability="props.props"
            :show-psf="false"
            :show-label="false"
          />
        </div>
        <div>
          <component
            :is="$options.components.AvailabilitySalesPriceLabel"
            :availability="props.props"
            :show-price="false"
            :show-label="false"
            hide-icons
          />
        </div>
        <div>
          <component
            :is="$options.components.Label"
            v-if="props.props.sale"
            :value="$options.methods.isValuePresent(props.props.sale.cap_rate) ? $options.filters.formatPercent(props.props.sale.cap_rate) : null"
          />
        </div>
      </template>
      <template v-else>
        <component :is="$options.components.Label" />
        <br>
        <component :is="$options.components.Label" />
        <br>
        <component :is="$options.components.Label" />
      </template>
    </td>
    <td class="sc-data-list-property-data">
      <span v-if="props.props.for_lease && props.props.lease_rate">
        {{ props.props.lease_rate | formatCurrency }} / {{ $options.methods.getRateEnteredAsLabel(props.props.lease.rate_entered_as) }}
        <br>
        {{ props.props.lease_type }}
        <v-tooltip v-if="props.props.lease_private === true" top>
          <template #activator="{ on, attrs }">
            <v-avatar
              color="red"
              size="16"
              v-bind="attrs"
              class="mr-1"
              v-on="on"
            >
              <span class="white--text text-caption">P</span>
            </v-avatar>
          </template>
          <span>The Lease Rate is Private</span>
        </v-tooltip><v-tooltip v-if="props.props.lease && props.props.lease.guidance_price === true" top>
          <template #activator="{ on, attrs }">
            <v-avatar
              color="blue"
              size="16"
              v-bind="attrs"
              v-on="on"
            >
              <span class="white--text text-caption">G</span>
            </v-avatar>
          </template>
          <span>The Lease Rate is a guidance rate</span>
        </v-tooltip></span>
      <span v-else class="na">N/A<br>N/A</span>
    </td>
    <td class="sc-data-list-property-data">
      <div v-if="props.props.opex">
        <component
          :is="$options.components.Label"
          :value="$options.methods.getAvailabilityExpensesLabel([{opex: props.props.opex}])"
        />
      </div>
      <div v-else-if="props.props.tmi">
        <component
          :is="$options.components.Label"
          :value="$options.methods.getAvailabilityExpensesLabel([{tmi: props.props.tmi}])"
        />
      </div>
      <div v-else>
        <component
          :is="$options.components.Label"
          :value="$options.methods.getAvailabilityExpensesLabel(props.props.operating_expenses)"
        />
      </div>
      <div>
        <span v-if="props.props.ti_allowance && !props.props.ti_negotiable">
          {{ props.props.ti_allowance | formatCurrency }}
        </span>
        <span v-else-if="props.props.ti_negotiable">Negotiable</span>
        <component :is="$options.components.Label" v-else />
      </div>
    </td>
    <td class="sc-data-list-property-data">
      <span v-if="props.props.date_available">{{ $options.methods.getDateAvailableLabel(props.props.date_available) }}</span>
      <component :is="$options.components.Label" v-else />
      <br>
      <span v-if="props.props.date_on_market" style="white-space: nowrap">
        {{ props.props.date_on_market | formatDate }}
        <small>({{ $options.methods.monthsOnMarket(props.props.date_on_market) }} months)</small>
      </span>
      <component :is="$options.components.Label" v-else />
    </td>
    <td class="sc-data-list-property-contacts">
      <div v-for="owner in props.props.true_owner" :key="owner._key">
        <router-link
          v-if="owner.company"
          :to="$options.methods.getAccountRoute({
            name: 'company',
            params: { id: owner.company._key },
            activeAccountId: props.activeAccountId
          })"
          class="company-name d-inline"
        >
          {{ owner.company.name }}
        </router-link>
      </div>
    </td>
    <td class="sc-data-list-property-contacts">
      <div v-if="$options.methods.getCompanyName(props.props.brokers)" class="mb-2">
        <component
          :is="$options.components.Label"
          :value="$options.methods.getCompanyName(props.props.brokers)"
        />
      </div>
      <div v-if="props.props.brokers && props.props.brokers.length">
        <component
          :is="$options.components.AvailabilityBrokersInfo"
          :brokers="props.props.brokers"
          :active-account-id="props.activeAccountId"
          with-tooltip-for-all-brokers
        />
      </div>
      <div v-else-if="props.props.property.brokers && props.props.property.brokers.length">
        <component
          :is="$options.components.AvailabilityBrokersInfo"
          :brokers="props.props.property.brokers"
          :active-account-id="props.activeAccountId"
          with-tooltip-for-all-brokers
        />
      </div>
      <div v-else>
        <span class="na">N/A</span>
      </div>
    </td>
    <td class="sc-data-list-updated-created">
      <div v-if="props.props.updated" class="updated-date">
        {{ props.props.updated.date | formatJSDateTime }}, {{ props.props.updated.name }}
      </div>
      <span v-else>
        N/A
      </span>
      <div v-if="props.props.created" class="created-date">
        {{ props.props.created.date | formatJSDateTime }}, {{ props.props.created.name }}
      </div>
      <span v-else>
        N/A
      </span>
      <div class="status-cd">
        {{ props.props.status }}
      </div>
      <component
        :is="$options.components.AvailabilityVerificationLabel"
        v-if="props.props.verification"
        :verification="props.props.verification"
      />
      <span v-else class="na">N/A</span>
      <div v-if="props.props.legacy_id" style="font-size: .8em; margin-top: 5px;">Legacy ID: {{ props.props.legacy_id }}</div>
      <component
        :is="$options.components.CustomFieldCell"
        v-if="props.customField"
        :title="$options.methods.getCustomFieldValue(props.props, props.customField)"
      >
        <component
          :is="$options.components.CustomFieldValue"
          :value="$options.methods.getCustomFieldValue(props.props, props.customField)"
        />
      </component>
    </td>
  </tr>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { getDateDiffAbs } from '@/utils/filters';
import { getAccountRouteHandler } from '@/bundles/App/helpers/accountRoute';
import { getNBRPropertyTypeClass } from '@/bundles/Property/helpers/colors/getNBRPropertyTypeClass';
import { roundToDecimal } from '@/bundles/App/helpers/mathHelpers';
import { getAvailabilityExpensesLabel } from '@/bundles/Property/helpers/expenses/getAvailabilityExpensesLabel';
import { getRateEnteredAsLabel } from '@/bundles/Availabilities/helpers/availabilityConsts';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { getDateAvailableLabel } from '@/bundles/Availabilities/helpers';
import { ConstructionStatusEnum } from '@/bundles/Property/types';
import { AvailabilityCustomFieldsEnum } from '@/bundles/Availabilities/types';
import { getCustomFieldValue } from '@/bundles/Availabilities/helpers/availabilityCustomFieldMapper';
import { Nullable } from '@/utils/types';

import Photo from '@/components/common-components/photo/Photo.vue';
import BuildingSizeLabel from '@/bundles/MeasurementUnits/components/BuildingSizeLabel.vue';
import LandSizeLabel from '@/bundles/MeasurementUnits/components/LandSizeLabel.vue';
import POLIcon from '@/bundles/Comparables/components/POLIcon.vue';
import AvailabilityVerificationLabel from '@/bundles/Availabilities/components/AvailabilityVerificationLabel.vue';
import AvailabilityChipsWrapper from '@/bundles/Availabilities/components/chips/AvailabilityChipsWrapper.vue';
import AvailabilityBrokersInfo from '@/bundles/Availabilities/components/content-view/common/AvailabilityBrokersInfo.vue';
import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';
import Label from '@/bundles/Common/components/Label.vue';
import CustomFieldValue from '@/bundles/BaseTable/components/CustomFieldValue.vue';
import CustomFieldCell from '@/bundles/BaseTable/components/CustomFieldCell.vue';
import BuildingDimensionLabels from '@/bundles/MeasurementUnits/components/BuildingDimensionLabels.vue';
import AvailabilitySalesPriceLabel from '@/bundles/Availabilities/components/cards/details/AvailabilitySalesPriceLabel.vue';

export default Vue.extend({
  name: 'ClientContent',

  components: {
    AvailabilitySalesPriceLabel,
    CommonChip,
    AvailabilityChipsWrapper,
    Photo,
    BuildingSizeLabel,
    LandSizeLabel,
    POLIcon,
    AvailabilityVerificationLabel,
    BuildingDimensionLabels,
    Label,
    CustomFieldCell,
    CustomFieldValue,
    AvailabilityBrokersInfo
  },

  props: {
    props: {
      type: Object,
      required: true,
    },
    selected: Boolean,
    displayBrokers: Boolean,
    displayOwners: Boolean,
    trackTour: Boolean,
    allowSelect: {
      type: Boolean,
      default: true
    },
    activeAccountId: {
      type: Number,
      required: true
    },
    allowLink: {
      type: Boolean,
      default: true
    },
    allowPhoto: {
      type: Boolean,
      default: true
    },
    allowCustomSort: Boolean,
    isCustomOrderLoading: Boolean,
    withTooltipForAllBrokers: Boolean,
    customField: {
      type: String as PropType<Nullable<AvailabilityCustomFieldsEnum>>,
      default: null,
    },
  },

  methods: {
    getCustomFieldValue,
    getDateAvailableLabel,
    isValuePresent,
    getNBRPropertyTypeClass,
    getAvailabilityExpensesLabel,
    getRateEnteredAsLabel,
    isLand (props) {
      return props.type?.toLowerCase() === 'land';
    },
    showVacancyStatus (props) {
      return props.property.construction_status === ConstructionStatusEnum.existing;
    },
    getComments (props) {
      const listingComments = props.listing_comments || '';
      const propertyComments = props.property_comments || '';

      if (listingComments && propertyComments) {
        return listingComments + ' -- ' + propertyComments;
      }

      if (listingComments && !propertyComments) {
        return listingComments;
      }

      return propertyComments;
    },
    monthsOnMarket (date) {
      const days = getDateDiffAbs(date, ['days']).days;

      return days < 30 ? roundToDecimal(days / 30, 1) : Math.round(days / 30);
    },
    getAccountRoute ({ name, params, activeAccountId }: {
      name: string;
      params: { id: number };
      activeAccountId: number;
    }) {
      return getAccountRouteHandler({
        name,
        params,
        activeAccountId
      });
    },
    getCompanyName (availabilityBrokers) {
      return availabilityBrokers?.[0]?.company?.name || '';
    },
  }
});
</script>

<style scoped>
.property-name {
  color: #000;
  font-weight: bold;
  display: block;
  text-decoration: none;
}
/* client table styles */
td.available-space {
  font-weight: 700;
}
.availability-list-photo {
  width: 150px;
  max-width: 100%;
}
</style>
